import { render } from "./DonorActivities.vue?vue&type=template&id=76553b82&scoped=true"
import script from "./DonorActivities.vue?vue&type=script&lang=js"
export * from "./DonorActivities.vue?vue&type=script&lang=js"

import "./DonorActivities.vue?vue&type=style&index=0&id=76553b82&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76553b82"]])

export default __exports__